/**
 *
 * GET DATA IN API
 * ?devis=1 : get products (inclus dans devis)
 * ?devis=0 : get products (non inclus dans devis)
 */
export async function getProducts(devis = null) {
  /* const url = new URL("https://independance-royale-outils.fr/php/get_products.php");
  if (devis !== null) {
    url.searchParams.append("devis", devis ? 1 : 0);
  } */
  let baseUrl;
  if (
    window.location.hostname === "localhost" ||
    window.location.hostname.startsWith("192.168.") ||
    window.location.hostname === "127.0.0.1" || window.location.hostname === "10.53.196.148"
  ) {
    // URL pour le local
    baseUrl = "https://independance-royale-outils.fr/php/get_products.php";
    //baseUrl = "https://clouddigital.fr/independanceRoyale/php/get_products.php"; // Remplace par l’URL de ton API locale 
  } else {
    // URL pour le serveur
    baseUrl = window.location.protocol + "//" + window.location.hostname;
  }

  const url = new URL(baseUrl + "/php/get_products.php");

  if (devis !== null) {
    url.searchParams.append("devis", devis ? 1 : 0);
  }

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error("Erreur lors de la récupération des produits !");
    }
    const data = await response.json();
    return data; // Return products by type
  } catch (error) {
    console.error("Erreur :", error);
  }
}
